import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
const BOTTOM_BORDER_STYLE = `${sizes.dynamicTable.rowBorderThickness} solid ${staticColors.dynamicTableRowDivider}`;
const StyledDynamicTableCell = styled('td', {
    borderBottom: BOTTOM_BORDER_STYLE,
});
export const DynamicTableCell = ({ children, rowId, CellClickableWrapper, rowData, columnId, }) => {
    const content = (_jsx(Box, { spacingVertical: '3/2', spacingHorizontal: true, children: _jsx(Text, { as: 'div', variant: 'b2', children: children }) }));
    const cellContent = CellClickableWrapper ? (_jsx(CellClickableWrapper, { rowData: rowData, rowId: rowId, columnId: columnId, children: content })) : (content);
    return _jsx(StyledDynamicTableCell, { children: cellContent });
};
